import React, { useState } from 'react'
import { adminRightUser, kasaRights, newFormatDisplayDate } from '../../../components/_utils/appUtils'
import { Tooltip } from 'antd'
import CyprusStatusChangeDrawer from '../drawers/changeStatusDrawer'
import { AllowComponentRightsWise } from '../../WebComponent/allowComponentRightsWise'

const CyprusVisaStatusComponent = (props) => {
  let { item, record, reloadFxn } = props
  let [visibleStatusChangeDrawer, setVisibleStatusChangeDrawer] = useState(false)

  const events = {
    showStatusChangeModal: async () => {
      setVisibleStatusChangeDrawer(true)
    },
    hideStatusChangeModal: async () => {
      setVisibleStatusChangeDrawer(false)
    }
  }

  return (
    <div className='fcmtDiv' style={{ width: 150 }}>
      {item && (item.fileOnHold || item.fileSubmittedStatus || item.fileReceivedStatus) && (() => {
        const statusObj = item.fileOnHold || item.fileSubmittedStatus || item.fileReceivedStatus
        return (
          <div>
            {statusObj.status}
            <br />
            {statusObj.date && (
              <>
                Date: {newFormatDisplayDate(statusObj.date)}
                <br />
              </>
            )}
            {statusObj.addedByUserName && (
              <>
                Updated By : {statusObj.addedByUserName}
                <br />
              </>
            )}
          </div>
        )
      })()}

      <AllowComponentRightsWise rightUserType={[...adminRightUser, 'branchManager', 'branchUser']}>
        {!item.fileSubmittedStatus && (
          <Tooltip title='Update Status'>
            <a className={'btn btn-default sm mt10 roundNew'}
               onClick={() => events.showStatusChangeModal(record)}>
              Update Status
            </a>
          </Tooltip>
        )}
      </AllowComponentRightsWise>

      {visibleStatusChangeDrawer ?
        <CyprusStatusChangeDrawer
          visible={visibleStatusChangeDrawer}
          onClose={events.hideStatusChangeModal}
          record={record}
          onSubmit={() => {
            events.hideStatusChangeModal()
            reloadFxn()
          }}
        /> : null
      }

    </div>
  )
}
export default CyprusVisaStatusComponent
